// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"bd765e53","496":"45be3d20","936":"91ed1cee","998":"e748e71e"}[chunkId] + ".chunk.js";
};